export default class temp_1 {
  static css = {
    header: {
      eMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '20px'
      },

      h2: {
        text_align: 'left',
        font_size: '30px'
      },

      // col_md_6: {
      //   background_color: '#f2f2f2',
      //   border_radius: '5px'
      // },

      mediaMax550__button_btn: {
        padding_left: '0px',
        padding_right: '0px'
      },

      mediaMax550__eMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '15px',
        margin_left: '5px',
        margin_right: '5px'
      }
    },

    login: {
      eMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '20px'
      },

      h4: {
        text_align: 'left'
      },

      col_md_6: {
        background_color: '#f2f2f2',
        border_radius: '5px'
      },

      mediaMax550__button_btn: {
        padding_left: '0px',
        padding_right: '0px'
      },

      mediaMax550__eMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '15px',
        margin_left: '5px',
        margin_right: '5px'
      }
    },

    mainList: {
      badgeQty: {
        background_color: 'blue'
      },

      itemPriceColor: {
        color: 'blue'
      },

      iPrice: {
        width: '50px',
        padding_left: '0px',
        padding_right: '0px'
      },
      border: {
        padding: '15px',
        border: '2px solid gainsboro',
        border_radius: '10px'
      },
      qtyBtn: {
        position: 'absolute',
        background_color: 'green',
        border_radius: '20px',
        top: '-10px',
        right: '-5px',
        width: '30px',
        height: '30px',
        padding: '0px'
      },
      deleteBtn: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        width: '25px',
        height: '25px',
        padding: '0px'
      },
      fix: {
        bottom: '2px',
        background_color: 'whitesmoke'
      },
      totalPayment: {
        margin_top: '10px'
      },
      mediaMax450__totalPayment: {
        font_size: '15px',
        margin_top: '10px'
      },
      mediaMax450__h3: {
        font_size: '20px'
      },
      mediaMax450__h4: {
        font_size: '15px'
      },
      mediaMax450__SCText: {
        font_size: '10px'
      }
    },

    register: {
      errorMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '20px'
      },

      h4: {
        text_align: 'left'
      },

      col_md_6: {
        background_color: '#f2f2f2',
        border_radius: '5px'
      },

      mediaMax550__button_btn: {
        padding_left: '0px',
        padding_right: '0px'
      },

      mediaMax550__errorMsg: {
        margin: '0px',
        margin_top: '10px',
        color: 'red',
        font_size: '15px',
        margin_left: '5px',
        margin_right: '5px'
      }
    },

    search: {
      tablenUMInput: {
        border: '1px solid #007bff'
      },

      startOrderBtn: {
        background_color: '#007bff',
        color: 'white'
      },

      typeBtnSize_selectedType: {
        background_color: '#007bff',
        color: 'white'
      },

      searchTxt: {
        font_size: '24px'
      },

      h3: {
        text_align: 'left'
      },

      bCol: {
        padding: '0px',
        height: 'auto'
      },

      bImg: {
        width: '100%',
        height: 'auto',
        padding: 'auto',
        object_fit: 'fill'
      },

      col_md_4: {
        float: 'right',
        background_color: '#f2f2f2',
        border_radius: '5px'
      },

      label: {
        font_size: '20px'
      },

      mediaMax1200__label: {
        font_size: '16px'
      },

      // setColHgh: {
      //   margin_bottom: '49px'
      // },

      // setColHgh2: {
      //   margin_bottom: '68px'
      // },

      mediaMax450__h3: {
        font_size: '18px'
      },

      mediaMax450__h4: {
        font_size: '15px'
      },

      mediaMax995__bImg: {
        height: 'auto'
      }
    },

    shoppingCart: {
      iPrice: {
        width: '50px',
        padding_left: '0px',
        padding_right: '0px'
      },
      border: {
        padding: '15px',
        border: '2px solid gainsboro',
        border_radius: '10px'
      },
      h2: {
        font: 'bold'
      },
      txtClrRed: {
        color: 'red'
      }
    }
  }
}
